/**
 * Modals Module (TypeScript)
 * Legacy guest tracking removed — now handled by guest-conversion-engine.ts
 */

/**
 * One-time cleanup of legacy localStorage keys.
 * Call on page init to remove stale data from v1 guest tracking.
 */
export function cleanupLegacyGuestKeys(): void {
  localStorage.removeItem('fortunio.yatzy.guestRolls');
  localStorage.removeItem('fortunio.yatzy.guestPlays');
  sessionStorage.removeItem('yatzy_signup_shown');
}
